import type { ReactNode } from "react";
import classnames from "classnames";
import {
  Table,
  TableBody,
  TableCell,
  TableFootRow,
  TableHeadingCell,
  TableHeadingRow,
  TableRow,
} from "@circle-react/components/shared/uikit/Table";

export interface Column {
  className?: string;
  dataIndex: string;
  key: string;
  shouldWrap?: boolean;
  tdClassName?: string;
  title: string;
  variant?: "actions" | "uppercase" | "no-x-padding";
}

export interface DataSource {
  [key: string]: unknown;
  isSelectable?: boolean;
  key: string;
  onClickColumns?: Record<string, () => void>;
  rowClassName?: string;
}

export interface DataTableProps {
  className?: string;
  columns: Column[] | ReadonlyArray<Column>;
  dataSource: DataSource[] | ReadonlyArray<DataSource>;
  dataTestId?: string;
  footer?: ReactNode;
  hasStickyHeader?: boolean;
  headerClassName?: string;
  tableBodyVariant?: "default" | "no-divider";
  variant?: "default" | "no-border" | "squared";
}

/** @deprecated Please use the new DataTable at "@circle-react-uikit/DataTableV2" */
export const DataTable = ({
  columns,
  dataSource,
  className,
  footer,
  variant = "default",
  tableBodyVariant,
  hasStickyHeader,
  headerClassName,
  dataTestId,
}: DataTableProps) => (
  <Table className={className} variant={variant} dataTestId={dataTestId}>
    <TableHeadingRow isSticky={hasStickyHeader} className={headerClassName}>
      {columns?.map(({ title, dataIndex, key, variant, className }) => (
        <TableHeadingCell
          key={key}
          variant={variant}
          {...(className && { className })}
        >
          {title || dataIndex}
        </TableHeadingCell>
      ))}
    </TableHeadingRow>
    <TableBody variant={tableBodyVariant}>
      {dataSource?.map(
        ({ key, isSelectable = false, rowClassName, ...data }) => (
          <TableRow
            key={key}
            isSelectable={isSelectable}
            className={rowClassName}
          >
            {columns?.map(
              ({ key: columnKey, dataIndex, tdClassName, shouldWrap }) => (
                <TableCell
                  key={`${key}-${columnKey}`}
                  onClick={data?.onClickColumns?.[dataIndex]}
                  className={classnames(tdClassName)}
                  shouldWrap={shouldWrap}
                >
                  {data?.[dataIndex]}
                </TableCell>
              ),
            )}
          </TableRow>
        ),
      )}
    </TableBody>
    {footer && <TableFootRow>{footer}</TableFootRow>}
  </Table>
);
